import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import defaultUser from '../../assets/img/default-user.svg';
import Header from '../../components/header';
import { VerifyUser } from './bb/CardManager/VerifyUser.jsx';
import Buildings from './Buildings.jsx';
import Apartments from './Apartments.jsx';
import AdminMenu from './AdminMenu.jsx';

import '../../components/form.css';
import '../../assets/css/adminDashboard.css';
import Camaras from '../camaras.js';
import UserManagement from './bb/UserManager/UserManagement.jsx';
import UsersByApartment from './bb/UserManager/UsersByApartment.jsx';
import EventIntrusionsMonitor from './bb/EventsMonitor/EventIntrusionsMonitor.jsx';
import EventOpenDoorMonitor from './bb/EventsMonitor/EventOpenDoorMonitor.jsx';
import MenuInferiorAdmin from '../../components/menuInferiorAdmin.jsx';
import RecentCriticalEventsMonitor from './bb/EventsMonitor/RecentCriticalEventsMonitor.jsx';
import ReadersModule from './bb/ReaderManager/ReadersModule.jsx';

const AdminDashboard = (props) => {
  const { match, location } = props;
  const isReadersActive = location && location.pathname && location.pathname.endsWith('/readers');

  return (
    <>
      <div className="App bg-blue flex-column">
        <Header userimage={defaultUser} />
        <div className={`dashboard-container admin-dashboard-container ${isReadersActive ? 'admin-dashboard-readers-active' : ''}`}>
          <div className="text-center text-white">
            <h3>Panel de Administración</h3>
          </div>
          <div className="row w-100 text-form m-0 flex-grow-1">
            <div className="col-sm-12 pl-3 pr-3">
              <Route exact path={match.path} component={AdminMenu} />
              <Route path={`${match.path}/card-manager`} component={VerifyUser} />
              <Route exact path={`${match.path}/buildings`} component={Buildings} />
              <Route exact path={`${match.path}/buildings/:buildingId/apartments`} component={Apartments} />
              <Route exact path={`${match.path}/buildings/:buildingId`} component={Camaras} />
              <Route exact path={`${match.path}/users`} component={UserManagement} />
              <Route exact path={`${match.path}/apartments/:apartmentId/users`} component={UsersByApartment} />
              <Route
                exact
                path={`${match.path}/events/event-intrusion/:buildingId?`}
                component={EventIntrusionsMonitor}
              />
              <Route exact path={`${match.path}/events/open-door/:buildingId?`} component={EventOpenDoorMonitor} />
              <Route exact path={`${match.path}/events/critical/recent`} component={RecentCriticalEventsMonitor} />
              <Route exact path={`${match.path}/readers`} component={ReadersModule} />
            </div>
          </div>
        </div>
      </div>
      <MenuInferiorAdmin />
    </>
  );
};
AdminDashboard.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

export default AdminDashboard;
